/**
 * Progress line under the gallery section's scrolling row.
 *
 * Reads the row's native scroll position rather than keeping its own index,
 * the same way carousel-arrows.js does, so swipes, trackpads and the arrows
 * all agree with the line.
 */
class GalleryProgress extends HTMLElement {
  connectedCallback() {
    this.track = this.closest('.section-gallery')?.querySelector('[data-carousel-track]');
    this.bar = this.querySelector('[data-progress-bar]');
    if (!this.track) return;

    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });

    // Cards grow as their images load, so measure on every resize.
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.track);

    this.update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.update);
    this.observer?.disconnect();
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;

    // A row that fits has nothing to report.
    this.hidden = scrollWidth - clientWidth <= 1;
    if (this.hidden) return;

    // The fill covers what has been seen so far, so it starts part-way along
    // (the first screenful) and reaches the end with the last card.
    this.bar.style.transform = `scaleX(${(scrollLeft + clientWidth) / scrollWidth})`;
  }
}

if (!customElements.get('gallery-progress')) {
  customElements.define('gallery-progress', GalleryProgress);
}
